import {AutogenLayoutPnnCodeManuallyAdd} from "./autogen/AutogenLayoutPnnCodeManuallyAdd";
import {BlurEvent, ClickEvent, DataSourceExecutionEvent} from "@mcleod/components";
import {ModelRow, StringUtil} from "@mcleod/core";
import {DuplicateId, DuplicateIdProps} from "../DuplicateId";

const viewProfileUrl = "/lme/dispatch/EquipmentTypeMaster?mode=update&key=";
const DUPLICATE_VALIDATION_PROPS: DuplicateIdProps = {
    tableName: "pnn_equip_type",
    screenName: "PNN Equipment Type Code",
    navigateToUrl: viewProfileUrl
}
export class PnnCodeManuallyAdd extends AutogenLayoutPnnCodeManuallyAdd{

    async buttonSaveOnClick(event: ClickEvent) {
        if (!this.validateSimple()) {
            return;
        }

        const newRow = new ModelRow("lme/dispatch/pnn-equip-type", false);
        newRow.set("id", this.textboxPnnCode.text);
        newRow.set("descr", this.textboxDescription.text);
        newRow.set("truckstop_code", this.textboxTruckStopCode.text);
        this.mainDataSource.addRow(newRow);
        try {
            await this.mainDataSource.post();
        } catch (error) {

        }
    }

    async textboxPnnCodeOnBlur(event: BlurEvent) {
        if(StringUtil.isEmptyString(this.textboxPnnCode.text)) {
            this.buttonSave.visible = false;
            return;
        }
        this.buttonSave.visible = await DuplicateId.isValidCode(this.textboxPnnCode, DUPLICATE_VALIDATION_PROPS);
        if(!this.buttonSave.visible) {
            this.textboxPnnCode.text = null;
        }
    }

    sourceAllLoadboardServicesBeforeExecution(event: DataSourceExecutionEvent) {
      event.filter = { service_type: "R", posting_format:"R" };
    }

    sourceAllLoadboardServicesAfterExecution(event : DataSourceExecutionEvent) {
      this.textboxTruckStopCode.visible = StringUtil.equalsIgnoreCase(event.data?.get("pbw_loadboard_services.is_active"), "Y")
          || StringUtil.equalsIgnoreCase(event.data?.get("load_board_service.is_active"), "Y");
    }
}
